import { render, staticRenderFns } from "./confirm-activate.vue?vue&type=template&id=23eaeead&"
import script from "./confirm-activate.vue?vue&type=script&lang=js&"
export * from "./confirm-activate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports